import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

const EquipoJunta = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editando, setEditando] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [resAsignaciones, resUsuarios] = await Promise.all([
          axios.get(
            `https://suadesarrollo.azurewebsites.net/api/JuntaDirectiva/ObtenerUsuariosSolicitud/${id}`,
          ),
          axios.get(
            "https://suadesarrollo.azurewebsites.net/api/ObtenerUsuariosJunta",
          ),
        ]);

        setData(resAsignaciones.data);
        setUsuarios(resUsuarios.data);
      } catch (error) {
        console.error("Error cargando datos", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchData();
  }, [id]);

  const handleUsuarioChange = (index, userId) => {
    const selectedUser = usuarios.find((u) => u.id === Number(userId));

    const newData = [...data];
    newData[index].usuarioId = selectedUser.id;
    newData[index].nombre = selectedUser.nombre;
    newData[index].rol =
      selectedUser.tipo_Usuario === "6" ? "DIRECTOR" : "JUNTA";

    setData(newData);
  };

  const guardar = async (item) => {
    try {
      const response = await axios.put(
        `https://suadesarrollo.azurewebsites.net/api/JuntaDirectiva/ActualizarAsignacion/${item.idAsignacion}`,
        {
          Rol: item.rol,
          UsuarioId: item.usuarioId,
          SolicitudId: item.solicitud,
          ConflictoInteres: false, // 🔥 SIEMPRE FALSE
        },
      );

      const res = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/JuntaDirectiva/ObtenerUsuariosSolicitud/${id}`,
      );

      setData(res.data);
      setEditando(null);

      Swal.fire({
        icon: "success",
        title: "Actualizado",
        text: response.data,
      });
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data
          ? JSON.stringify(error.response.data)
          : "Error al actualizar usuario",
      });
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="m-0">Usuarios de la Solicitud</h5>
        </div>

        <div className="card-body">
          <p>
            <strong>Institución:</strong> {data[0]?.nombreInstitucion}
          </p>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Usuario</th>
                  <th>Rol</th>
                  <th>Conflicto</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>

              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.idAsignacion}</td>

                    <td>{item.nombre}</td>

                    {/* Usuario */}
                    <td>
                      {editando === index ? (
                        <select
                          className="form-control"
                          value={item.usuarioId || ""}
                          onChange={(e) =>
                            handleUsuarioChange(index, e.target.value)
                          }
                        >
                          <option value="">Seleccione usuario</option>
                          {usuarios.map((u) => (
                            <option key={u.id} value={u.id}>
                              {u.nombre}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span className="badge badge-info">{item.nombre}</span>
                      )}
                    </td>

                    {/* Rol */}
                    <td>
                      <span className="badge badge-primary">{item.rol}</span>
                    </td>

                    {/* Conflicto (solo visual) */}
                    <td>
                      {item.conflictoInteres ? (
                        <span className="badge badge-danger">
                          Tiene conflicto
                        </span>
                      ) : (
                        <span className="badge badge-success">
                          Sin conflicto
                        </span>
                      )}
                    </td>

                    {/* Estado */}
                    <td>
                      {item.respondio ? (
                        <span className="badge badge-success">Respondió</span>
                      ) : (
                        <span className="badge badge-warning">Pendiente</span>
                      )}
                    </td>

                    {/* Acciones */}
                    <td>
                      {editando === index ? (
                        <>
                          <button
                            className="btn btn-success btn-sm mr-2"
                            onClick={() => guardar(item)}
                          >
                            Guardar
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => setEditando(null)}
                          >
                            Cancelar
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => setEditando(index)}
                        >
                          Editar
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquipoJunta;
